/**
 * EvolveRPG marketing copy (the /free page and the Quickstart form).
 * There is no EvolveRPG Quickstart PDF yet, so nothing here promises a download:
 * the form joins a list and the Quickstart is emailed the day it's ready (the BFF
 * returns `pending` until QUICKSTART_DOWNLOAD_URL is set). No em dashes.
 */
export const marketingEvoEn = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'The EvolveRPG Quickstart',
  'marketing.free.seo.description':
    "The EvolveRPG Quickstart is still being written. Join the list and we'll email it to you the day it's ready.",
  'marketing.free.eyebrow': 'Free, coming when the rules are ready',
  'marketing.free.heading': 'The Quickstart is on its way',
  'marketing.free.subheadLead': 'The',
  'marketing.free.quickstartName': 'EvolveRPG Quickstart',
  'marketing.free.subheadTail':
    "is still being written. Join the list and we'll email it to you the day it's ready.",
  'marketing.free.benefit.rules.title': 'What it will cover',
  'marketing.free.benefit.rules.body': 'How a character starts at zero and grows, the die ladder and the six tracks.',
  'marketing.free.benefit.oneShot.title': 'Free',
  'marketing.free.benefit.oneShot.body': 'The Quickstart will be free.',
  'marketing.free.benefit.livingWorld.title': 'Play while you wait',
  'marketing.free.benefit.livingWorld.body': 'The early demo is open now. Sign in, make a character, and walk into Montkelian.',
  'marketing.free.playInstead.heading': 'Rather just play?',
  'marketing.free.playInstead.body': 'Open the play lobby to make a character and walk the city.',
  'marketing.free.playInstead.cta': 'Go to the play lobby',

  // LeadCaptureForm
  'marketing.leadForm.ready': 'Your free Quickstart is ready.',
  'marketing.leadForm.downloadCta': 'Download your Quickstart',
  'marketing.leadForm.alsoEmailed': "We've also sent the link to your inbox.",
  'marketing.leadForm.pending': "You're on the list. We'll email you the Quickstart the day it's ready.",
  'marketing.leadForm.defaultCta': 'Join the list',
  'marketing.leadForm.privacyNote': "We'll only email you about the Quickstart and EvolveRPG news. Unsubscribe anytime.",
} as const
